import axios from 'axios';
import {fetchConfig} from '../util/util';

const HOST_URL = fetchConfig('hostUrl')

const getAll = async () => {
  return (await axios.get(`${HOST_URL}/provider-monitoring-view`)).data;
};

const post = async (data) => {
  return (await axios.post(`${HOST_URL}/provider-monitoring`, data)).data;
};

const put = async (id, data) => {
  return (await axios.put(`${HOST_URL}/provider-monitoring/${id}`, data)).data;
};

const remove = async (id) => {
  return (await axios.delete(`${HOST_URL}/provider-monitoring/${id}`)).data;
};

export default {getAll, post, put, remove};
